import React from 'react';
import {FormWrapper, Title} from "../../../components/PatientSurvey/PatientSurvey.styles";
import {formFields} from "../../../assets/data/survey/survey-form-field";
import PatientSurveyField from "../../../components/PatientSurvey";
import {useTranslation} from "react-i18next";

const SurveyFormsComponent = ({
                                  formData,
                                  formErrors,
                                  handleInputChange,
                                  handleReactSelectChange,
                                  handleReactMultiSelectChange
                              }) => {
    const {t} = useTranslation("common");

    return (
        <FormWrapper>
            <Title>{t("glacies_biome_questionare")}</Title>
            {formFields.map((field) => {
                return (
                    <PatientSurveyField
                        key={field.name}
                        name={field.name}
                        field={field}
                        value={formData[field.name]}
                        error={formErrors[field.name]}
                        onChange={
                            field.type === "multi-select" || field.type === "creatable-multi-select"
                                ? handleReactMultiSelectChange
                                : field.type === "select"
                                    ? handleReactSelectChange
                                    : handleInputChange
                        }
                    />
                )
            })}
        </FormWrapper>
    );
};

export default SurveyFormsComponent;